import { useQuery } from 'react-query';

import { UIUser } from '../../../../../packages/types/src/user';
import { getPresignedUrl, getUser, getUserProfile } from '../../apis/V2/auth';
import { getAllBadges, getUserStreak } from '../../apis/V2/profile';
import { getResumes } from '../../apis/V2/resume';

export function useUser() {
	return useQuery({
		queryKey: 'getUser',
		queryFn: async () => (await getUser()).data.user as UIUser,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}

export function useStreaks() {
	return useQuery({
		queryKey: 'getUserStreak',
		queryFn: async () => (await getUserStreak()).data.streakCount as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}
export function useAllBadges() {
	return useQuery({
		queryKey: 'getAllBadges',
		queryFn: async () => (await getAllBadges()).data as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}

export function useUserProfile() {
	return useQuery({
		queryKey: 'getUserProfile',
		queryFn: async () => (await getUserProfile()).data.userProfile,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}

export function useGetProfileImagePresignedUrl() {
	return useQuery({
		queryKey: 'getProfileImagePresignedUrl',
		queryFn: async () => (await getPresignedUrl()).data,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}

export function useResumes() {
	return useQuery({
		queryKey: 'getResumes',
		queryFn: async () => (await getResumes()).data?.data,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
}
